import { memo } from 'react';
function RightSidebarSkeleton() {
  return (
    <div className="p-4 space-y-6 animate-pulse">
      {/* Heading Section */}
      <div className="space-y-2">
        <div className="flex items-center gap-4">
          <div className="w-48 h-6 bg-gray-200 rounded"></div> {/* Job Title */}
          <div className="w-24 h-6 bg-gray-200 rounded"></div> {/* Status Badge */}
        </div>
        <div className="w-32 h-4 bg-gray-200 rounded"></div> {/* Company Name */}
        <div className="flex gap-4">
          <div className="w-32 h-3 bg-gray-200 rounded"></div> {/* Created by */}
          <div className="w-32 h-3 bg-gray-200 rounded"></div> {/* Created on */}
        </div>
        <div className="flex flex-wrap gap-2">
          <div className="w-24 h-3 bg-gray-200 rounded"></div> {/* Experience */}
          <div className="w-28 h-3 bg-gray-200 rounded flex items-center gap-1"></div> {/* Location */}
          <div className="w-20 h-3 bg-gray-200 rounded"></div> {/* Job Type */}
        </div>
      </div>

      {/* Value Cards Section */}
      <div className="flex justify-between gap-2">
        <div className="w-20 sm:w-24 h-20 bg-gray-200 rounded"></div>
        <div className="w-20 sm:w-24 h-20 bg-gray-200 rounded"></div>
        <div className="w-20 sm:w-24 h-20 bg-gray-200 rounded"></div>
      </div>

      {/* Tabs Section */}
      <div className="flex gap-2 w-[80%]">
        <div className="w-24 h-8 bg-gray-200 rounded"></div>
        <div className="w-24 h-8 bg-gray-200 rounded"></div>
      </div>

      {/* Job Description Card */}
      <div className="w-full h-32 bg-gray-200 rounded"></div>

      {/* Skills Section */}
      <div className="p-6 w-[90%] ml-5 card-base space-y-2">
        <div className="w-32 h-6 bg-gray-200 rounded"></div> {/* Skill Criteria Heading */}
        <div className="space-y-2">
          {Array.from({ length: 10 }).map((_, idx) => (
            <div key={idx} className="w-full h-5 bg-gray-200 rounded"></div>
          ))}
        </div>
      </div>
    </div>
  );
}


export default memo(RightSidebarSkeleton);
